<template>
  <ValidationProvider
    :ref="validationProviderRef"
    :mode="veeValidateInteractionMode"
    :rules="rules"
    :vid="validationProviderRef"
    :name="label"
    :immediate="true"
  >
    <template v-slot="{ errors }">
      <div ref="elementToDetectOutsideClick">
        <v-text-field
          :id="validationProviderRef"
          v-model="mutableValue"
          :suggestionItems="suggestionItems"
          :errorMessages="errors"
          :label="label ? displayedLabel : null"
          :required="isRequired"
          :hideDetails="hideDetails"
          :disabled="disabled"
          :readonly="readonly"
          v-bind="$attrs"
          v-on="$listeners"
          @input="handleInput"
        />
        <template v-if="suggestions.length && showSuggestions">
          <div>
            <v-list class="vlist">
              <v-subheader v-if="suggestionListHeader">
                {{ suggestionListHeader }}
              </v-subheader>
              <v-list-item
                v-for="item in suggestions"
                :key="item.id"
                @click.stop="setSelected(item)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.label" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </template>
      </div>
    </template>
  </ValidationProvider>
</template>


<script>
import { ValidationProvider } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';

export default {
    components: {
        ValidationProvider,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        label: {
            type: String,
            default: '',
        },
        rules: {
            type: Object,
            default: () => ({ required: false, max: 200 }),
        },
        hideDetails: {
            type: [String, Boolean],
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        suggestionItems: {
            type: Array,
            default: () => [],
        },
        suggestionListHeader: {
            type: String,
            default: '',
        },
        itemText: {
            type: String,
            default: 'label',
        },
        value: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            mutableValue: null,
            showSuggestions: false,
            suggestions: [],
        };
    },
    computed: {
        isRequired() {
            return Object.keys(this.rules).some(rule => (rule === 'required' && this.rules[rule]));
        },
        displayedLabel() {
            return `${this.label} ${this.isRequired ? '*' : ''}`;
        },
    },
    watch: {
        value: {
            handler(newValue) {
                this.mutableValue = newValue;
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        this.suggestions = this.suggestionItems;
        // on click outside the element the suggestion list will be hidden
        document.addEventListener('click', this.handleClickOutside);
    },
    methods: {
        setSelected(item) {
            this.mutableValue = item[this.itemText];
            this.showSuggestions = false;
            this.$emit('input', this.mutableValue);
        },
        handleInput() {
            this.suggestions = this.suggestionItems.filter(item => item[this.itemText].toLowerCase().includes(this.mutableValue.toLowerCase()));
            this.showSuggestions = true;
        },
        handleClickOutside(event) {
            // if outside the elementToDetectOutsideClick element is clicked
            if (!this.$refs.elementToDetectOutsideClick?.contains(event.target)) this.showSuggestions = false;
        },
    },

};
</script>
<style scoped>
  ::v-deep .v-text-field--outlined fieldset {
    border-color: var(--border-color) !important;
  }
  .vlist {
    position: absolute;
    width: calc(100% - 23px);
    height: 200px;
    overflow-y: scroll;
    z-index: 10000;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
</style>
